import { render, staticRenderFns } from "./FormLongitud.vue?vue&type=template&id=f4adbd90&scoped=true"
import script from "./FormLongitud.vue?vue&type=script&lang=js"
export * from "./FormLongitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4adbd90",
  null
  
)

export default component.exports